import { useEffect } from 'react';

import { isModalOpen } from 'src/utils/is-modal-open';
import analyticsClient, { AnalyticsEvent } from 'src/services/analytics';
import type { IConversation } from 'src/api/landlord-messages-api';
import type { IConversationMatchWithChannel } from 'src/pages/landlord/conversations/context/types';

type Props = {
    focusedConversation?: IConversation;
    openConversation: (conversation: IConversation | IConversationMatchWithChannel, backPath: string) => void;
};

/**
 * Open the focused conversation when the enter key is pressed.
 */
export const useOpenConversationWithEnterKey = ({
    focusedConversation,
    openConversation
}: Props) => {

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter' && !isModalOpen()) {
                event.preventDefault();

                if (focusedConversation) {
                    analyticsClient.track(AnalyticsEvent.SHORTCUT_KEY_USED, {
                        page: 'Conversations',
                        key: 'Enter',
                    });

                    openConversation(focusedConversation, window.location.pathname + window.location.search);
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [focusedConversation, openConversation]);
};
